import { useState } from 'react'
import { FaRegCopy, FaCheck } from 'react-icons/fa'
import SecondaryButton from 'components/Buttons/SecondaryButton'

/* Copia `text` e mostra "Copiado!" por 2 segundos, no visual do botão secundário. */
export default function CopyButton({ text, label = 'Copiar link', style }) {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Falha ao copiar!', error)
    }
  }

  return (
    <SecondaryButton
      label={copied ? 'Copiado!' : label}
      leftIcon={copied ? <FaCheck/> : <FaRegCopy/>}
      onClick={copyToClipboard}
      style={style}
    />
  )
}
